export const Action_StorePreRegistrationDetails = 'STORE_PRE_REGISTRATION_DETAILS';
export const Action_StorePreRegistrationValidationResult = 'STORE_PRE_REGISTRATION_VALIDATION_RESULT';
export const Action_ClearPreRegistrationInfo = 'CLEAR_PRE_REGISTRATION_INFO';
export const Action_SetGDPRCOMPLIANCE = 'SET_GDPRCOMPLIANCE';
export const Action_SetGDPRAcceptance = 'SET_GDPRACCEPTANCE';
export const Action_SetCurrentUser = 'SET_CURRENT_USER';
export const Action_ClearCurrentUser = 'SET_CURRENT_USER';
export const Action_StoreForgotPasswordDetails = 'STORE_FORGOT_PASSWORD_DETAILS';
export const Action_ClearForgotPasswordDetails = 'CLEAR_FORGOT_PASSWORD_DETAILS';
export const Action_SetAgentUserObjectToCompleteRegistration = 'SET_AGENT_USEROBJECT_TO_COMPLETE_REGISTRATION';
export const Action_Set_CurrentUserType = 'SET_CURRENT_USER_TYPE';



